{
  "itemsShipped": [
    "16",
    "18",
    "20",
    "22",
    "24",
    "78",
    "88",
    "90",
    "91",
    "92",
    "174",
    "176",
    "180",
    "182",
    "184",
    "186",
    "188",
    "190",
    "192",
    "248",
    "250",
    "252",
    "254",
    "256",
    "257",
    "258",
    "259",
    "260",
    "262",
    "264",
    "266",
    "268",
    "270",
    "271",
    "272",
    "274",
    "276",
    "278",
    "280",
    "281",
    "282",
    "283",
    "284",
    "289",
    "296",
    "300",
    "303",
    "304",
    "305",
    "306",
    "307",
    "308",
    "330",
    "334",
    "335",
    "336",
    "337",
    "338",
    "340",
    "342",
    "344",
    "346",
    "348",
    "350",
    "376",
    "378",
    "380",
    "382",
    "384",
    "386",
    "388",
    "390",
    "392",
    "393",
    "394",
    "396",
    "397",
    "398",
    "399",
    "400",
    "402",
    "404",
    "406",
    "408",
    "410",
    "412",
    "414",
    "416",
    "417",
    "418",
    "420",
    "421",
    "422",
    "424",
    "426",
    "428",
    "430",
    "432",
    "433",
    "436",
    "438",
    "440",
    "442",
    "444",
    "445",
    "446",
    "447",
    "454",
    "459",
    "591",
    "593",
    "595",
    "597",
    "613",
    "614",
    "634",
    "635",
    "636",
    "637",
    "638",
    "684",
    "709",
    "724",
    "725",
    "726",
    "766",
    "767",
    "768",
    "769",
    "771",
    "787",
    "807",
    "812",
    "814",
    "815",
    "829",
    "830",
    "832",
    "834",
    "848",
    "851",
    "881",
    "909",
    "910",
    "SmokedFish",
    "Moss",
    "MysticSyrup",
    "Raisins",
    "DriedFruit",
    "DriedMushrooms",
    "Carrot",
    "SummerSquash",
    "Broccoli",
    "Powdermelon"
  ],
  "fish": [
    "128",
    "129",
    "130",
    "131",
    "132",
    "136",
    "137",
    "138",
    "139",
    "140",
    "141",
    "142",
    "143",
    "144",
    "145",
    "146",
    "147",
    "148",
    "149",
    "150",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "160",
    "161",
    "162",
    "163",
    "164",
    "165",
    "267",
    "269",
    "372",
    "682",
    "698",
    "699",
    "700",
    "701",
    "702",
    "704",
    "705",
    "706",
    "707",
    "708",
    "715",
    "716",
    "717",
    "718",
    "719",
    "720",
    "721",
    "722",
    "723",
    "734",
    "775",
    "795",
    "796",
    "798",
    "799",
    "800",
    "836",
    "837",
    "838",
    "RiverJelly",
    "CaveJelly",
    "SeaJelly",
    "Goby"
  ],
  "artifacts": [
    "96",
    "97",
    "98",
    "99",
    "100",
    "101",
    "103",
    "104",
    "105",
    "106",
    "107",
    "108",
    "109",
    "110",
    "111",
    "112",
    "113",
    "114",
    "115",
    "116",
    "117",
    "118",
    "119",
    "120",
    "121",
    "122",
    "123",
    "124",
    "125",
    "126",
    "127",
    "579",
    "580",
    "581",
    "582",
    "583",
    "584",
    "585",
    "586",
    "587",
    "588",
    "589"
  ],
  "minerals": [
    "60",
    "62",
    "64",
    "66",
    "68",
    "70",
    "72",
    "74",
    "80",
    "82",
    "84",
    "86",
    "538",
    "539",
    "540",
    "541",
    "542",
    "543",
    "544",
    "545",
    "546",
    "547",
    "548",
    "549",
    "550",
    "551",
    "552",
    "553",
    "554",
    "555",
    "556",
    "557",
    "558",
    "559",
    "560",
    "561",
    "562",
    "563",
    "564",
    "565",
    "566",
    "567",
    "568",
    "569",
    "570",
    "571",
    "572",
    "573",
    "574",
    "575",
    "576",
    "577",
    "578"
  ],
  "cooking": [
    "Fried Egg",
    "Omelet",
    "Salad",
    "Cheese Cauliflower",
    "Baked Fish",
    "Parsnip Soup",
    "Vegetable Medley",
    "Complete Breakfast",
    "Fried Calamari",
    "Strange Bun",
    "Lucky Lunch",
    "Fried Mushroom",
    "Pizza",
    "Bean Hotpot",
    "Glazed Yams",
    "Carp Surprise",
    "Hashbrowns",
    "Pancakes",
    "Salmon Dinner",
    "Fish Taco",
    "Crispy Bass",
    "Pepper Poppers",
    "Bread",
    "Tom Kha Soup",
    "Trout Soup",
    "Chocolate Cake",
    "Pink Cake",
    "Rhubarb Pie",
    "Cookie",
    "Spaghetti",
    "Fried Eel",
    "Spicy Eel",
    "Sashimi",
    "Maki Roll",
    "Tortilla",
    "Red Plate",
    "Eggplant Parmesan",
    "Rice Pudding",
    "Ice Cream",
    "Blueberry Tart",
    "Autumn's Bounty",
    "Pumpkin Soup",
    "Super Meal",
    "Cranberry Sauce",
    "Stuffing",
    "Farmer's Lunch",
    "Survival Burger",
    "Dish O' The Sea",
    "Miner's Treat",
    "Roots Platter",
    "Triple Shot Espresso",
    "Seafoam Pudding",
    "Algae Soup",
    "Pale Broth",
    "Plum Pudding",
    "Artichoke Dip",
    "Stir Fry",
    "Roasted Hazelnuts",
    "Pumpkin Pie",
    "Radish Salad",
    "Fruit Salad",
    "Blackberry Cobbler",
    "Cranberry Candy",
    "Coleslaw",
    "Fiddlehead Risotto",
    "Poppyseed Muffin",
    "Bruschetta",
    "Chowder",
    "Fish Stew",
    "Escargot",
    "Lobster Bisque",
    "Maple Bar",
    "Crab Cakes",
    "Shrimp Cocktail",
    "Ginger Ale",
    "Banana Pudding",
    "Mango Sticky Rice",
    "Poi",
    "Tropical Curry",
    "Squid Ink Ravioli",
    "Moss Soup"
  ],
  "crafting": [
    "Bomb",
    "Cherry Bomb",
    "Mega Bomb",
    "Gate",
    "Hardwood Fence",
    "Iron Fence",
    "Stone Fence",
    "Wood Fence",
    "Big Chest",
    "Big Stone Chest",
    "Chest",
    "Stone Chest",
    "Dark Sign",
    "Stone Sign",
    "Text Sign",
    "Wood Sign",
    "Bee House",
    "Cask",
    "Cheese Press",
    "Dehydrator",
    "Fish Smoker",
    "Keg",
    "Loom",
    "Mayonnaise Machine",
    "Oil Maker",
    "Preserves Jar",
    "Bait Maker",
    "Bone Mill",
    "Charcoal Kiln",
    "Crystalarium",
    "Deluxe Worm Bin",
    "Furnace",
    "Geode Crusher",
    "Heavy Furnace",
    "Heavy Tapper",
    "Lightning Rod",
    "Mushroom Log",
    "Ostrich Incubator",
    "Recycling Machine",
    "Seed Maker",
    "Slime Egg-Press",
    "Slime Incubator",
    "Tapper",
    "Worm Bin",
    "Iridium Sprinkler",
    "Quality Sprinkler",
    "Sprinkler",
    "Barrel Brazier",
    "Campfire",
    "Carved Brazier",
    "Gold Brazier",
    "Iron Lamp-post",
    "Jack-O-Lantern",
    "Marble Brazier",
    "Skull Brazier",
    "Stone Brazier",
    "Stump Brazier",
    "Torch",
    "Wood Lamp-post",
    "Wooden Brazier",
    "Deluxe Scarecrow",
    "Garden Pot",
    "Hopper",
    "Scarecrow",
    "Tub o' Flowers",
    "Wicked Statue",
    "Drum Block",
    "Flute Block",
    "Glowstone Ring",
    "Iridium Band",
    "Ring of Yoba",
    "Sturdy Ring",
    "Thorns Ring",
    "Warrior Ring",
    "Bait",
    "Barbed Hook",
    "Challenge Bait",
    "Cork Bobber",
    "Crab Pot",
    "Deluxe Bait",
    "Dressed Spinner",
    "Magic Bait",
    "Magnet",
    "Quality Bobber",
    "Sonar Bobber",
    "Spinner",
    "Trap Bobber",
    "Treasure Hunter",
    "Wild Bait",
    "Brick Floor",
    "Crystal Floor",
    "Rustic Plank Floor",
    "Stone Floor",
    "Stone Walkway Floor",
    "Straw Floor",
    "Weathered Floor",
    "Wood Floor",
    "Cobblestone Path",
    "Crystal Path",
    "Gravel Path",
    "Stepping Stone Path",
    "Wood Path",
    "Ancient Seeds",
    "Basic Fertilizer",
    "Basic Retaining Soil",
    "Blue Grass Starter",
    "Deluxe Fertilizer",
    "Deluxe Retaining Soil",
    "Deluxe Speed-Gro",
    "Fiber Seeds",
    "Grass Starter",
    "Hyper Speed-Gro",
    "Mystic Tree Seed",
    "Quality Fertilizer",
    "Quality Retaining Soil",
    "Speed-Gro",
    "Tea Sapling",
    "Tree Fertilizer",
    "Wild Seeds (Fa)",
    "Wild Seeds (Sp)",
    "Wild Seeds (Su)",
    "Wild Seeds (Wi)",
    "Cookout Kit",
    "Rain Totem",
    "Tent Kit",
    "Treasure Totem",
    "Warp Totem: Beach",
    "Warp Totem: Desert",
    "Warp Totem: Farm",
    "Warp Totem: Island",
    "Warp Totem: Mountains",
    "Field Snack",
    "Bug Steak",
    "Explosive Ammo",
    "Fairy Dust",
    "Life Elixir",
    "Monster Musk",
    "Oil Of Garlic",
    "Anvil",
    "Farm Computer",
    "Mini-Forge",
    "Mini-Jukebox",
    "Mini-Obelisk",
    "Solar Panel",
    "Staircase",
    "Statue Of Blessings",
    "Statue Of The Dwarf King",
    "Transmute (Au)",
    "Transmute (Fe)"
  ]
}
